function deparam(dataString) {
  // 예시: 'iframe_id=crema-fullscreen-popup-1&act=set_parent_div_margin&style=' 문자열을 hash 값으로 변경
  // {iframe_id: 'crema-fullscreen-popup-1', act: 'set_parent_div_margin', style: ''}
  return typeof dataString === 'string'
    ? dataString.split('&').reduce(function(result, param) {
        var [key, value] = param.split('=');
        result[key] = value;
        return result;
      }, {})
    : {};
}

function decodeValue(value) {
  if (value == null) return value;
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
}

function getBaseUrl(url) {
  return /https?:\/\//.test(url)
    ? url.split('?')[0]
    : window.location.protocol + '//' + url.split('?')[0];
}

function isIframe() {
  return window.self !== window.top;
}

function setStyle(el, spec) {
  for (var n in spec) {
    el.style[n] = spec[n];
  }
}

// https://stackoverflow.com/questions/16839698/jquery-getscript-alternative-in-native-javascript
function getScript(source, callback) {
  let script = document.createElement('script');
  let prior = document.getElementsByTagName('script')[0];
  script.async = 1;
  script.onload = script.onreadystatechange = function(_, isAbort) {
    if (
      isAbort ||
      !script.readyState ||
      /loaded|complete/.test(script.readyState)
    ) {
      script.onload = script.onreadystatechange = null;
      script = undefined;
      if (!isAbort && callback) setTimeout(callback, 0);
    }
  };
  script.src = source;
  prior?.parentNode?.insertBefore(script, prior);
}

export { decodeValue, deparam, getBaseUrl, getScript, isIframe, setStyle };
